import PropTypes from 'prop-types'
import React from 'react'

import ABaseLink from './ABaseLink'

/** Component used for links that use onclicks

@example ../../../../docs/external/link/ALink.md*/

const ALink = ({
  onClick,
  label,
  className,
  to,
  newWin,
  internal,
  cmpLabel,
  cmpTitle,
  tabIndex,
  cmpRel,
  stopClickEventPropogation,
}) => (
  <ABaseLink
    style={className}
    onClick={onClick}
    to={to}
    newWin={newWin}
    internal={internal}
    cmpLabel={cmpLabel}
    cmpTitle={cmpTitle}
    tabIndex={tabIndex}
    cmpRel={cmpRel}
    stopClickEventPropogation={stopClickEventPropogation}
  >
    <span className={'action-link'}>{label}</span>
  </ABaseLink>
)

ALink.propTypes = {
  /** link label */
  label: PropTypes.string.isRequired,
  /** function to run on click of link */
  onClick: PropTypes.func.isRequired,
  /** wrapper classname for custom styles */
  className: PropTypes.string,

  /** url for the link */
  to: PropTypes.string,
  /** should the link open in a new window - overrides cmpTarget */
  newWin: PropTypes.bool,
  /** is link internal - if yes then no server request will be sent - link will be opened by single page app */
  internal: PropTypes.bool,
  /** alt text for link */
  cmpLabel: PropTypes.string,
  /** title for link */
  cmpTitle: PropTypes.string,
  /** tab index for contents */
  tabIndex: PropTypes.number,
  /** rel attribute */
  cmpRel: PropTypes.arrayOf(PropTypes.string),
  /** should click event propogtion be stopped */
  stopClickEventPropogation: PropTypes.bool,
}

export default ALink
